<template>
  <div class="UpcomingDeadlines panel">
    <h4>Upcoming Deadlines</h4>
    <div class="activities">
      <div v-if="empty">
        Relax, you're all good.
      </div>
      <template v-for="reportType of reports">
        <div
          class="activity"
          v-for="report of reportType"
          @click="gotoReport(report)"
          :key="report.id">
          <div class="badge">
            {{ report | reportName }}
          </div>
          <div class="info">
            Remember to submit your {{ report | reportName | lowercase }} for
            {{ report.periodEnd | month }}
            <div class="deadline">
              {{ report.periodEnd | deadline }}
            </div>
          </div>
        </div>
      </template>
    </div>
    <!-- activities -->

    <div class="footer">
      <IconButton
        icon="report"
        @click="gotoReports()">
        Go to my reports
      </IconButton>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
export default {
  data: function () {
    return {
      reports: { sales: [], activities: [] },
    };
  },
  methods: {
    gotoReports() {
      this.$router.push({ name: "reports", params: { show: "sales" } });
    },
    gotoReport(report) {
      if (report.__typename === "SalesReport") {
        this.$router.push({ name: "sales-report", params: { id: report.id }});
      }
      if (report.__typename === "ActivityReport") {
        this.$router.push({ name: "activity-report", params: { id: report.id }});
      }
    }
  },

  filters: {
    month(val) {
      return moment(val).format("MMMM YYYY");
    },
    deadline(val) {
      return moment(val).add(1, "days").format("MMMM D, YYYY");
    },
    reportName(val) {
      return val.__typename === "SalesReport"
        ? "Sales report"
        : "Activity report";
    },
    lowercase(val) {
      return val.toLowerCase();
    },
  },

  computed: {
    empty() {
      const r = this.reports;
      return r.sales.length === 0 && r.activities.length === 0;
    },
  },

  apollo: {
    reports() {
      return {
        fetchPolicy: "no-cache",
        query: gql`
          query DeadlineQuery {
            salesReportsList(condition: { status: DRAFT }) {
              id
              periodEnd
              status
            }
            activityReportsList(condition: { status: DRAFT }) {
              id
              periodEnd
              status
            }
          }
        `,
        update: (data) => {
          return {
            sales: data.salesReportsList,
            activities: data.activityReportsList,
          };
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.UpcomingDeadlines {
  display: flex;
  flex-direction: column;
  padding: 1em;

  h4 {
    text-transform: uppercase;
    padding-bottom: 3em;
  }

  .activities {
    margin-bottom: auto;
  }

  .activity {
    display: flex;
    align-items: flex-start;
    cursor: pointer;
  }

  .badge {
    background-color: var(--pinkish-red);
    font-size: 0.857em;
    color: white;
    padding: 0.5em;
    border-radius: 13px;
    white-space: nowrap;
    text-align: center;
    flex: 1;
  }

  .info {
    flex: 1;
    padding-left: 1em;
    color: var(--blue-purple);
    flex: 4;
  }

  .deadline {
    color: var(--pinkish-red);
  }

  .footer {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
